export const GET_DAILY_EVENTS = "GET_DAILY_EVENTS";
export const GET_HOURLY_EVENTS = "GET_HOURLY_EVENTS";
export const GET_STATS_DAILY = "GET_STATS_DAILY";
export const GET_STATS_HOURLY = "GET_STATS_HOURLY";
export const GET_POI = "GET_POI";
export const GET_STATS_DAILY_CHART = "GET_STATS_DAILY_CHART";
export const ERROR = "ERROR";